import { render, staticRenderFns } from "./JoinForm.vue?vue&type=template&id=5e0d2530&scoped=true"
import script from "./JoinForm.vue?vue&type=script&lang=ts"
export * from "./JoinForm.vue?vue&type=script&lang=ts"
import style0 from "./JoinForm.vue?vue&type=style&index=0&id=5e0d2530&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e0d2530",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {FileInput: require('/web/components/FileInput.vue').default})
